import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
  })
export class CommonService {
    baseUrl: string | undefined;
    private httpClient: HttpClient;
    private  sidebarshowhide =new BehaviorSubject<any>(true)
    getshowhidesidebar=this.sidebarshowhide.asObservable();
    private selectedTemplateSource = new BehaviorSubject<any>(null);
  selectedTemplate$ = this.selectedTemplateSource.asObservable();

    data: any;
  templateData: any;
    
    setSidebar(data: any){
        this.sidebarshowhide.next(data);
    }
    constructor(private http: HttpClient, handler: HttpBackend){
        this.httpClient = new HttpClient(handler);
    }
    getMethod(data: any): Observable<any>{
        return this.http.get(environment.mainApi + data)
    }
    getpMethod(data: any): Observable<any>{
      return this.http.get(environment.papi + data)
    }
    postMethod(data: any, payload: any): Observable<any>{
        return this.http.post(environment.mainApi + data, payload)
    }
    postpMethod(data: any, payload: any): Observable<any>{
      return this.http.post(environment.papi + data, payload)
    }
    putMethod(data: any, payload: any): Observable<any>{
        return this.http.put(environment.mainApi + data, payload)
    }
    putpMethod(data: any, payload: any): Observable<any>{
      return this.http.put(environment.papi + data, payload)
    }
    getProfundityMethod(data: any): Observable<any>{
      return this.http.get(environment.profundityBotUrl + data)
    }
    putProfundityMethod(data: any, payload: any): Observable<any>{
      return this.http.put(environment.profundityBotUrl + data, payload)
    }
    deleteMethod(url: any,params:any): Observable<any>{     
        return this.http.request('DELETE', environment.mainApi + url, {body: params});
    }
    deletepMethod(url: any,params:any): Observable<any>{     
      return this.http.request('DELETE', environment.papi + url, {body: params});
  }
    syncFileMethod(filename:any,payload:any):Observable<any>{
        return this.putMethod('CollectionSynchronization?fullSync=true&collection='+filename,payload)
    }
    singleFileSyncMethod(collection:any,file:any,payload: any):Observable<any>{
        return this.putMethod(`singleFileSync?collection=${collection}&document_name=${file}`,payload)
    }
    getWithParams(endpoint: string, params?: Record<string, any>): Observable<any> {
        const httpParams = params ? new HttpParams({ fromObject: params }) : new HttpParams();
        return this.http.get(environment.mainApi + endpoint, { params: httpParams });
      }
    uploadFiles(collectionName: string, files: File[], token: string): Observable<any> {
        const formData = new FormData();
        formData.append('collection_name', collectionName);
        
        files.forEach((file) => {
          formData.append('documents', file);
        });
    
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
    
        return this.httpClient.post(environment.webapi + 'upload-collection-files/v2', formData, { headers });
      }
      setData(data: any): void {
        localStorage.setItem("DocData", JSON.stringify(data));  
        }
    
      getData(): any {
        const data = localStorage.getItem("DocData");
        return data ? JSON.parse(data) : null;
      }
     
      clearData(): void {
        localStorage.removeItem("DocData");
      }
      fetchDocument(payload:any):Observable<any>{
        return this.postMethod('get-collection-documents', payload)
    }
    setSelectedTemplate(template: any) {
      this.selectedTemplateSource.next(template);
    }
    patchMethod(data:any,payload:any):Observable<any>{
      return this.http.patch(environment.mainApi+ data,payload);
    }
    
}
